(function () {
var $8bbaa2b013e28aa2$export$e1252723db1c541 = {
    activeItem: '.anchor-navigation__item.active',
    footer: 'footer.footer',
    header: 'header.header',
    highlightSection: 'section[data-color-scheme="highlight"]',
    item: '.anchor-navigation__item',
    nav: '.anchor-navigation'
};
var $8bbaa2b013e28aa2$export$188d75d71883854a = {
    hide: 'hide',
    show: 'show',
    active: 'active'
};


var $b987114743678d16$export$99d98991c45140b5 = function(el) {
    el.classList.remove((0, $8bbaa2b013e28aa2$export$188d75d71883854a).show);
    el.classList.add((0, $8bbaa2b013e28aa2$export$188d75d71883854a).hide);
    $b987114743678d16$export$456617f45f17a0b1();
};
var $b987114743678d16$export$58d0df4febc888cf = function(el) {
    el.classList.remove((0, $8bbaa2b013e28aa2$export$188d75d71883854a).hide);
    el.classList.add((0, $8bbaa2b013e28aa2$export$188d75d71883854a).show);
};
var $b987114743678d16$export$456617f45f17a0b1 = function() {
    var activeItem = document.querySelector((0, $8bbaa2b013e28aa2$export$e1252723db1c541).activeItem);
    if (activeItem) activeItem.classList.remove((0, $8bbaa2b013e28aa2$export$188d75d71883854a).active);
};
var $b987114743678d16$export$78fbabf588056ffc = function(item) {
    // Continue if current nav item is not already active
    if (!item.classList.contains('active')) {
        // Remove active state from other possible item
        $b987114743678d16$export$456617f45f17a0b1();
        // Add active state to current nav item
        item.classList.add((0, $8bbaa2b013e28aa2$export$188d75d71883854a).active);
    }
};
var $b987114743678d16$export$28ddd5749d69cc40 = function(container) {
    container.querySelectorAll((0, $8bbaa2b013e28aa2$export$e1252723db1c541).item).forEach(function(el) {
        var target = el.getAttribute('data-target');
        var section = target ? document.getElementById(target) : null;
        el.hidden = !(section === null || section === void 0 ? void 0 : section.checkVisibility());
    });
};
var $b987114743678d16$export$2497853127c8bf56 = function(container) {
    var anchors = [];
    container.querySelectorAll((0, $8bbaa2b013e28aa2$export$e1252723db1c541).item).forEach(function(el) {
        var target = el.getAttribute('data-target');
        var section = target ? document.getElementById(target) : null;
        if (section) anchors.push(section);
    });
    return anchors;
};



var $5eaafc9ffdea0f61$var$anchorNav = document.querySelector((0, $8bbaa2b013e28aa2$export$e1252723db1c541).nav);
if ($5eaafc9ffdea0f61$var$anchorNav) {
    var $5eaafc9ffdea0f61$var$setHighlightColorScheme = function() {
        return $5eaafc9ffdea0f61$var$anchorNav.setAttribute('data-color-scheme', 'highlight');
    };
    var $5eaafc9ffdea0f61$var$removeHighlightColorScheme = function() {
        return $5eaafc9ffdea0f61$var$anchorNav.removeAttribute('data-color-scheme');
    };
    window.addEventListener('resize', function() {
        return (0, $b987114743678d16$export$28ddd5749d69cc40)($5eaafc9ffdea0f61$var$anchorNav);
    });
    (0, $b987114743678d16$export$28ddd5749d69cc40)($5eaafc9ffdea0f61$var$anchorNav);
    var $5eaafc9ffdea0f61$var$anchors = (0, $b987114743678d16$export$2497853127c8bf56)($5eaafc9ffdea0f61$var$anchorNav);
    var $5eaafc9ffdea0f61$var$navItemStates = {};
    $5eaafc9ffdea0f61$var$anchors.forEach(function(anchor) {
        return $5eaafc9ffdea0f61$var$navItemStates[anchor.id] = false;
    });
    // * Initialize IntersectionObserver which observes all sections with a anchor
    var $5eaafc9ffdea0f61$var$observer = new IntersectionObserver(function(entries) {
        for(var i = 0; i < entries.length; i++){
            var entry = entries[i];
            var entryId = entry.target.id;
            if (entry.isIntersecting) $5eaafc9ffdea0f61$var$navItemStates[entryId] = entry.intersectionRatio;
            else if ($5eaafc9ffdea0f61$var$navItemStates[entryId] !== false) $5eaafc9ffdea0f61$var$navItemStates[entryId] = false;
        }
        var maxIntersectionRatio = 0;
        var activeNavItem = false;
        for(var id in $5eaafc9ffdea0f61$var$navItemStates)if ($5eaafc9ffdea0f61$var$navItemStates[id] !== false && $5eaafc9ffdea0f61$var$navItemStates[id] > maxIntersectionRatio) {
            activeNavItem = id;
            maxIntersectionRatio = $5eaafc9ffdea0f61$var$navItemStates[id];
        }
        var activeNavItemElement = activeNavItem ? $5eaafc9ffdea0f61$var$anchorNav.querySelector('li[data-target="'.concat(activeNavItem, '"]')) : null;
        if (activeNavItemElement) (0, $b987114743678d16$export$78fbabf588056ffc)(activeNavItemElement);
        else (0, $b987114743678d16$export$456617f45f17a0b1)();
    }, {
        threshold: [
            0,
            0.25,
            0.5,
            0.75,
            1
        ]
    });
    // * Observe elements
    $5eaafc9ffdea0f61$var$anchors.forEach(function(anchor) {
        return $5eaafc9ffdea0f61$var$observer.observe(anchor);
    });
    // Build a second Observer which is observing all sections
    var $5eaafc9ffdea0f61$var$highlightSectionObserverCallback = function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                if (entry.intersectionRatio > 0.25) $5eaafc9ffdea0f61$var$setHighlightColorScheme();
                else $5eaafc9ffdea0f61$var$removeHighlightColorScheme();
            }
        });
    };
    var $5eaafc9ffdea0f61$var$colorObserver = new IntersectionObserver($5eaafc9ffdea0f61$var$highlightSectionObserverCallback, {
        threshold: [
            0,
            0.25,
            0.5,
            0.75,
            1
        ],
        rootMargin: '-150px 0px -200px 0px'
    });
    document.querySelectorAll((0, $8bbaa2b013e28aa2$export$e1252723db1c541).highlightSection).forEach(function(section) {
        return $5eaafc9ffdea0f61$var$colorObserver.observe(section);
    });
    // Hide anchor navigation when footer comes in viewport
    var $5eaafc9ffdea0f61$var$footer = document.querySelector((0, $8bbaa2b013e28aa2$export$e1252723db1c541).footer);
    if ($5eaafc9ffdea0f61$var$footer) {
        var $5eaafc9ffdea0f61$var$footerObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) (0, $b987114743678d16$export$99d98991c45140b5)($5eaafc9ffdea0f61$var$anchorNav);
                else (0, $b987114743678d16$export$58d0df4febc888cf)($5eaafc9ffdea0f61$var$anchorNav);
            });
        }, {
            rootMargin: "0px 0px ".concat(-0.5 * window.innerHeight, "px 0px")
        });
        $5eaafc9ffdea0f61$var$footerObserver.observe($5eaafc9ffdea0f61$var$footer);
    }
    // Show anchor navigation
    // TODO: Show anchor navigation below header
    $5eaafc9ffdea0f61$var$anchorNav.classList.add((0, $8bbaa2b013e28aa2$export$188d75d71883854a).show);
}

})();
//# sourceMappingURL=anchor_navigation.min.js.map
